export default "__VITE_ASSET__CDw_aQRx__"